//export const taxRate = 0.0;
export const taxRate = 0.05;
